/**
 * @file Utility that needs description.
 * @copyright Copyright (c) 2018-present, Graham Fairweather
 * @module _fallbackSymbolIterator
 */

export default '@@iterator';
